import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW4600Model } from '../kymw4600.model';
import { TagGroupInfo } from '../vo/tag-group-info.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
type GetTagGroupListResponse = {
  TagGroupId: string;
  TagGroupName: string;
  TagList: { TagId: string; TagName: string }[];
}[];

/**
 * タググループ一覧取得サービス
 * @export GetTagGroupListService
 * @class GetTagGroupListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetTagGroupListService extends PlessJsonResponderSub<GetTagGroupListResponse> {
  model: KYMW4600Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetTagListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest();
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetTagListService
   */
  execute(model: KYMW4600Model, f: () => void = null): void {
    this.model = model;
    this.calbak = f;
    this.send('getTagGroupList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetTagListService
   */
  success(data: GetTagGroupListResponse) {
    this.model.tagGroupListOrigin = data.map(
      _ =>
        new TagGroupInfo(
          _.TagGroupId,
          _.TagGroupName,
          _.TagList.map(t => {
            return { tagId: t.TagId, tagName: t.TagName };
          })
        )
    );
    this.model.tagGroupListForEdit = data.map(
      _ =>
        new TagGroupInfo(
          _.TagGroupId,
          _.TagGroupName,
          _.TagList.map(t => {
            return { tagId: t.TagId, tagName: t.TagName };
          })
        )
    );
    if (this.calbak) this.calbak();
  }
}
